import React, { forwardRef } from "react";

import { type ToggleProps, SupToggle } from "./components/Toggle";

export type CheckboxProps = Omit<ToggleProps, "renderIcon" | "inputType">;

const renderCheckboxIcon = (checked: boolean) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {checked && <path d="M15.3536 6.85355L14.6464 6.14645L8 12.7929L5.35355 10.1464L4.64645 10.8536L8 14.2071L15.3536 6.85355Z" fill="currentColor" />}
    <path fillRule="evenodd" clipRule="evenodd" d="M2 2H18V18H2V2ZM3 3H17V17H3V3Z" fill="currentColor" />
  </svg>
);

export const SupCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
  return <SupToggle ref={ref} {...props} inputType="checkbox" renderIcon={renderCheckboxIcon} />;
});
